<div *ngIf="horizontalMenu" class="navbar-header d-xl-block d-none">
  <!-- Navbar brand -->
  <ul class="nav navbar-nav flex-row">
    <li class="nav-item">
      <a class="navbar-brand" [routerLink]="['/']">
        <span class="brand-logo">
          <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" width="36" />
        </span>
        <h2 class="brand-text mb-0">{{ coreConfig.app.appName }}</h2>
      </a>
    </li>
  </ul>
  <!--/ Navbar brand -->
</div>

<div class="navbar-container d-flex content">
  <div class="bookmark-wrapper d-flex align-items-center">
    <!-- Menu Toggler | Menu icon will be hidden in case of layout without menu -->
    <ul class="nav navbar-nav d-xl-none" *ngIf="!coreConfig.layout.menu.hidden">
      <li class="nav-item">
        <a class="nav-link menu-toggle" (click)="toggleSidebar('menu')">
          <span [data-feather]="'menu'" [class]="'ficon'"></span>
        </a>
      </li>
    </ul>
    <!--/ Menu Toggler -->
   
    <ul class="nav navbar-nav align-items-center ml-auto">

    <!-- Action Dropdown -->
    <li ngbDropdown class="nav-item">
      <a
        class="nav-link dropdown-toggle nav-link-style btn disabled"
        [ngClass]="{ disabled: currentUser['location'].length < 1 }"
        id="dropdown-action"
        ngbDropdownToggle
        aria-haspopup="true"
        aria-expanded="false"
      >
        <button type="button" class="btn btn-icon btn-icon rounded-circle btn-primary"><span [data-feather]="'plus'"></span></button>
      </a>
      <div ngbDropdownMenu aria-labelledby="navbarUserDropdown" class="dropdown-menu dropdown-menu-left">
        <a ngbDropdownItem [routerLink]="['/apps/member/member-new']">
          <span [class]="'mr-50'"></span> Add New Member
        </a>
        <a ngbDropdownItem [routerLink]="['/apps/member/member-payment']" >
          <span [class]="'mr-50'"></span> Create Payment
        </a>
      </div>
    </li>
    <!--/ Action Dropdown -->
      
      <!-- Invite -->
      <app-navbar-invite></app-navbar-invite>
      <!--/ Invite -->

      <!-- Search -->
      <app-navbar-search></app-navbar-search>
      <!--/ Search -->

    </ul>
    <!-- Bookmark -->
    <!-- <app-navbar-bookmark></app-navbar-bookmark> -->
    <!--/ Bookmark -->

  </div>
  <ul class="nav navbar-nav align-items-center ml-auto">
    <!-- Language selection -->
    <!-- <li ngbDropdown class="nav-item dropdown dropdown-language">
      <a class="nav-link dropdown-toggle" id="dropdown-flag" ngbDropdownToggle>
        <i class="flag-icon flag-icon-{{ languageOptions[_translateService.currentLang].flag }}"></i
        ><span class="selected-language">{{ languageOptions[_translateService.currentLang].title }}</span></a
      >
      <div ngbDropdownMenu aria-labelledby="dropdown-flag">
        <a *ngFor="let lang of _translateService.getLangs()" ngbDropdownItem (click)="setLanguage(lang)">
          <i class="flag-icon flag-icon-{{ languageOptions[lang].flag }}"></i> {{ languageOptions[lang].title }}
        </a>
      </div>
    </li> -->
    <!--/ Language selection -->
    <!-- Offer -->
    <li class="nav-item d-lg-block mr-2" *ngIf="!offer.accepted"> 
      <button class="btn btn-outline-primary round" (click)="offerViewer()"     
      >
      <img [src]="offer.image" alt="Rocket" width="24" height="24" class="mr-0">
      {{offer.name}}</button>
    </li>
    <!-- Offer -->
    <!-- Upgrade Now -->
    <li class="nav-item d-lg-block mr-2" *ngIf="!isActive"> 
      <button class="btn btn-primary round" (click)="openPricing()"     
      >Upgrade Now</button>
    </li>
    <!-- Upgrade Now -->
    <!-- Toggle skin -->
    <li class="nav-item d-none d-lg-block">
      <a class="nav-link nav-link-style btn" (click)="toggleDarkSkin()">
        <span [ngClass]="currentSkin === 'dark' ? 'icon-sun' : 'icon-moon'" class="ficon font-medium-5 feather"></span>
      </a>
    </li>
    <!--/ Toggle skin -->
    

    <!-- Cart -->
    <!-- <app-navbar-cart></app-navbar-cart> -->
    <!--/ Cart -->

    <!-- Notification -->
    <!-- <app-navbar-notification></app-navbar-notification> -->
    <!--/ Notification -->

    
    <!-- Action Dropdown -->
    <li ngbDropdown class="nav-item">
      <a
        class="nav-link dropdown-toggle nav-link-style btn"
        [ngClass]="{ disabled: currentUser['location'].length < 1 }"
        id="dropdown-action"
        ngbDropdownToggle
        aria-haspopup="true"
        aria-expanded="false"
      >
        <span [data-feather]="'map-pin'" class="ficon font-medium-5 feather"></span>
      </a>
      <div ngbDropdownMenu aria-labelledby="navbarUserDropdown" class="dropdown-menu dropdown-menu-left">
        <a ngbDropdownItem  href="javascript:void(0);" [disabled]="location.locationStatus != 'active'" (click)="setLocation(location.id)" *ngFor="let location of this.currentUser.location">
          <span [ngClass]="currentUser.sessionLocation == location.id ? 'icon-check-circle' : 'icon-circle'" class="ficon font-medium-5 feather"></span>

           {{location.locationName}}
        </a>
      </div>
    </li>
    <!--/ Action Dropdown -->
    <!-- User Dropdown -->
    <li ngbDropdown class="nav-item dropdown-user">
      <a
        class="nav-link dropdown-toggle dropdown-user-link"
        id="dropdown-user"
        ngbDropdownToggle
        id="navbarUserDropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <ng-container *ngIf="this.currentUser">
          <div class="user-nav d-sm-flex d-none">
            <span class="user-name font-weight-bolder"
              >{{ this.currentUser.firstName }} {{ this.currentUser.lastName }}</span
            ><span class="user-status">{{ this.currentUser.role }}</span>
          </div>
            <div
              class="avatar mr-1 ml-0"
              [ngClass]="{
                'bg-light-success': currentUser.status == 'active',
                'bg-light-secondary': currentUser.status == 'inactive',
                'bg-light-warning': currentUser.status == 'pending'
              }"
            >
              <div class="avatar-content">{{ currentUser.firstName | initials }}</div>
            </div>
        </ng-container>
      </a>
      <div ngbDropdownMenu aria-labelledby="navbarUserDropdown" class="dropdown-menu dropdown-menu-right">
        <a ngbDropdownItem [routerLink]="['pages/account-settings']"
          ><span [data-feather]="'user'" [class]="'mr-50'"></span> Profile</a
        ><a ngbDropdownItem [routerLink]="['/pages/support']"
          ><span [data-feather]="'help-circle'" [class]="'mr-50'"></span> Support</a
        ><a ngbDropdownItem (click)="logout()"><span [data-feather]="'power'" [class]="'mr-50'"></span> Logout</a>
      </div>
    </li>
    <!--/ User Dropdown -->
  </ul>
</div>

<!-- Modal -->
<ng-template #modalOffer let-modal>
  <!-- <div class="modal-header">
    <button
      type="button"
      class="close"
      (click)="modal.dismiss('Cross click')"
      aria-label="Close"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div> -->

  <div class="modal-body" tabindex="0" ngbAutofocus>
    <div *ngIf="isSmallScreen" class="alert alert-warning d-flex flex-column align-items-center mt-3 text-center">
      <img src="assets/images/icons/phone_rotate.png" alt="Rotate Phone" width="300" height="300" class="mb-3">
      <h4>Please rotate your phone for the best experience!</h4>
    </div>
    <div class="p-0" *ngIf="!isSmallScreen">
      <div class="content-body">
        <div class="container py-0">
          <div class="row align-items-start">
            <div class="col-sm-12 col-md-12 col-lg-9 mb-1">
              <div class="d-flex align-items-center mb-1">
                <img [src]="offer.image" alt="Rocket" width="80" height="80" class="me-2">
                <h1 class="h3 mb-0" style="font-size: 30px;" id="offer_title"></h1>
              </div>
              
              <div class="ml-3">
                <h3 class="fw-semibold" id="offer_subtitle"></h3>
                <p id="offer_description"></p>
          
                <h3 class="mt-3 mb-1">What’s Included:</h3>
                <ul class="list-unstyled">
                  <li *ngFor="let item of offer.benefits" class="d-flex align-items-start mb-2">
                    <img src="assets/images/icons/green_check.png" alt="Rocket" width="30" height="30" class="mr-1">
                    <span>{{ item }}</span>
                  </li>
                </ul>
          
                <p class="fw-semibold mt-2">
                  <strong>Success Guarantee:</strong> 
                  <span id="offer_guarantees"></span>
                </p>
              </div>
            </div>
        
            <!-- Right - Price -->
            <div class="col-sm-12 col-md-12 col-lg-3 text-lg-end text-start pl-4" style="place-self: anchor-center;">
              <p class="mb-1" id="offer_price_description"></p>
              <h1 class="fw-bold text-dark mb-0" style="font-size: 60px;" id="offer_price_final_value">{{offer.price.final_value}}</h1>
              <p class="badge bg-success me-2" style="font-size: 20px;" id="offer_price_discount">{{offer.price.discount}}</p>
              <span class="text-muted ml-2" style="font-size: 30px;" id="offer_price_value"><s class="strikethrough-thin">{{offer.price.value}}</s></span>
            </div>
          </div>
        
          <!-- Bts -->
          <div class="row mt-1">
            <div class="col-sm-12 col-md-12 col-lg-6 mb-3">
              <button class="btn btn-primary w-100 py-2 fw-semibold" [disabled]="loadingButton" (click)="acceptOffer()" style="font-size: large;">
                <div class="row" style="justify-content: center;">
                 <span *ngIf="loadingButton" class="spinner-border spinner-border-sm mr-1"></span>
                  <span class="m-0" id="offer_buttons_accept"></span>
                </div>
              </button>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-6 mb-3">
              <button class="btn btn-outline-primary w-100 py-2 fw-semibold" [disabled]="loadingButton" style="font-size: large;" (click)="denyOffer()" id="offer_buttons_deny">

              </button>
            </div>
          </div>    
        </div>    
      </div>
    </div>
  </div>
</ng-template>
<!-- / Modal -->